export default __webpack_public_path__ + "static/media/bitmart.fcb20423.svg";